<template>
  <div class="news-widget">
    <Toolbar class="news-widget__toolbar">
      <template #title>
        Новости
      </template>
    </Toolbar>

    <div class="news-widget__wrap">
      <masonry :cols="cols" :gutter="14">
        <NewsWidgetItem
          v-for="(item, index) in list"
          :key="index"
          :item="item"
          class="news-widget__item"
        />
      </masonry>
    </div>

    <AppBtn
      v-if="!firstLoading && hasNext"
      type="button"
      class="news-widget__btn"
      color="third"
      :loading="loading"
      @click="getNews"
    >
      Показать еще
    </AppBtn>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar";
import NewsWidgetItem from "./NewsWidgetItem";
import service from "@/services/news";

export default {
  name: "NewsWidget",

  components: {
    Toolbar,
    NewsWidgetItem
  },

  props: {
    limit: {
      type: Number,
      default: 3
    }
  },

  data: () => ({
    loading: false,
    list: new Array(3),
    hasNext: true,
    offset: 0
  }),

  computed: {
    cols() {
      const { mdAndDown, xsOnly } = this.$core.breakpoint;
      if (xsOnly) return 1;
      if (mdAndDown) return 2;
      return 3;
    },
    firstLoading() {
      return !this.list[0];
    }
  },

  watch: {
    params: {
      deep: true,
      immediate: true,
      handler: "getNews"
    }
  },

  methods: {
    async getNews() {
      if (this.loading) return;

      this.loading = true;
      let { data, success, pagination } = await service.getList({
        offset: this.offset
      });

      if (success) {
        if (this.firstLoading) {
          this.list = data;
        } else {
          this.list = this.list.concat(data);
        }

        this.hasNext = pagination.nextPage;
        this.offset = pagination.offset;
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.news-widget {
  z-index: 1;
  position: relative;

  &__toolbar {
    margin-bottom: 20px;
    position: relative;
    z-index: 2;
  }

  .toolbar__wrap {
    position: relative;
    z-index: 2;
  }

  &__btn {
    display: flex;
    margin: 25px auto 0;
    font-size: 20px;
    text-transform: uppercase;
    height: 50px;
    width: 300px;
  }
}
</style>
